import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './hsr-element.scss';

interface IProps {
  charClass: string;
}

export const HSRRarity: React.FC<IProps> = ({ charClass }) => {
  const popoverElement = (
    <Popover id="popover-element">
      <Popover.Header as="h3">{charClass}★</Popover.Header>
      <Popover.Body>
        This character/Light Cone rarity is {charClass}★
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverElement}
    >
      <div className={`hsr-rarity rar-${charClass}`}>{charClass}★</div>
    </OverlayTrigger>
  );
};
